import { apiService } from './apiService';
import { API_ENDPOINTS, STORAGE_KEYS, ERROR_MESSAGES } from '../constants/apiConstants';

export const authService = {
  // Admin login
  login: async (credentials) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.ADMIN_LOGIN, {
        email: credentials.email,
        password: credentials.password
      });

      const { data } = response;
      
      // Store tokens and user data in localStorage
      if (data.token || data.access_token) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.token || data.access_token);
      }
      
      if (data.refresh_token) {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refresh_token);
      }
      
      if (data.user || data.admin) {
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(data.user || data.admin));
      }

      return {
        success: true,
        data: data,
        message: data.message || 'Login successful'
      };
    } catch (error) {
      console.error('Login error:', error);
      
      let errorMessage = ERROR_MESSAGES.SERVER_ERROR;
      
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = error.response.data?.message || ERROR_MESSAGES.VALIDATION_ERROR;
            break;
          case 401:
            errorMessage = ERROR_MESSAGES.INVALID_CREDENTIALS;
            break;
          case 404:
            errorMessage = 'Login endpoint not found';
            break;
          case 500:
            errorMessage = ERROR_MESSAGES.SERVER_ERROR;
            break;
          default:
            errorMessage = error.response.data?.message || ERROR_MESSAGES.SERVER_ERROR;
        }
      } else if (error.request) {
        errorMessage = ERROR_MESSAGES.NETWORK_ERROR;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Admin logout
  logout: async () => {
    try {
      await apiService.post(API_ENDPOINTS.ADMIN_LOGOUT);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear local storage regardless of API response
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER_DATA);
      localStorage.removeItem(STORAGE_KEYS.REMEMBER_ME);
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    return !!token;
  },

  // Get current user data
  getCurrentUser: () => {
    const userData = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    return userData ? JSON.parse(userData) : null;
  },

  // Get access token
  getAccessToken: () => {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  },

  // Refresh token
  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await apiService.post(API_ENDPOINTS.REFRESH_TOKEN, {
        refresh_token: refreshToken
      });

      const { data } = response;
      
      if (data.token || data.access_token) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.token || data.access_token);
      }

      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Refresh token error:', error);
      
      // If refresh fails, logout user
      this.logout();
      
      return {
        success: false,
        message: ERROR_MESSAGES.SESSION_EXPIRED
      };
    }
  }
};